var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileUpdateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#39996B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.475 13.494C23.8769 13.092 24.4221 12.8662 24.9905 12.8662C25.5589 12.8662 26.1041 13.092 26.506 13.494C26.908 13.8959 27.1338 14.4411 27.1338 15.0095C27.1338 15.5779 26.908 16.1231 26.506 16.525L16.9076 26.1234L12.8662 27.1338L13.8766 23.0924L23.475 13.494Z",
    stroke: "white",
    strokeWidth: 1.39535,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileUpdateIcon);
export default __webpack_public_path__ + "static/media/profileUpdateIcon.e1a1e537dcb42c33b34d0fb8cadd1475.svg";
export { ForwardRef as ReactComponent };